import { render, staticRenderFns } from "./szgl.vue?vue&type=template&id=2e987763&scoped=true&"
import script from "./szgl.vue?vue&type=script&lang=js&"
export * from "./szgl.vue?vue&type=script&lang=js&"
import style0 from "./szgl.vue?vue&type=style&index=0&id=2e987763&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e987763",
  null
  
)

export default component.exports